var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 218,
    height: 44,
    viewBox: "0 0 218 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -449,
    y: -327,
    width: 794,
    height: 1123
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M-449 -327H344.701V795.52H-449V-327Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M217.728 43.4284L200.147 18.6751L216.685 0.497739H206.995L187.615 22.5151V0.497739H179.397V43.4284H187.615V32.4497L194.471 24.9151L207.853 43.4284H217.728ZM74.7106 27.3604L67.048 8.77641L59.4173 27.3604H74.7106ZM71.5253 0.497739L90.108 43.4284H81.3373L77.468 34.0457H56.672L52.82 43.4284H44.2333L63.1226 0.497739H71.5253ZM30.7413 0.497739H39.02V43.4284H30.7413V25.8271H9.33732V43.4284H1.11865V0.497739H9.33732V19.0191H30.7413V0.497739Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.228 5.11319L139.285 2.43985L133.189 4.84385L137.228 5.11319ZM154.456 35.4945C152.861 40.2439 148.4 43.4359 143.381 43.4359H143.247L133.459 21.3799L123.441 43.4359C118.423 43.4359 113.961 40.2239 112.347 35.4745L103.289 8.57452C101.944 4.61319 104.885 0.498522 109.077 0.498522H109.385L119.865 28.5145L130.485 4.49585C130.836 3.69985 131.504 3.08652 132.325 2.80252L141.083 -0.220146C142.144 -0.586813 143.336 0.00118618 143.604 1.09185C144.268 3.79985 144.055 7.42119 144.055 7.42119L142.32 6.19985C141.933 5.92785 141.407 5.97452 141.073 6.31052L138.997 8.40119L147.419 28.6105L157.783 0.498522C161.975 0.498522 164.917 4.61319 163.571 8.57452L154.456 35.4945ZM95.7375 40.0199L96.8508 43.4279H103.573L95.0228 18.4119C93.1268 25.5279 93.3748 33.0452 95.7375 40.0199ZM97.5028 18.2959L106.003 43.4279H112.724L100.113 6.50785C97.1175 9.64519 96.1122 14.1865 97.5028 18.2959ZM171.896 18.4119L163.344 43.4279H170.067L171.181 40.0199C173.543 33.0452 173.792 25.5279 171.896 18.4119ZM169.415 18.2959L160.916 43.4279H154.193L166.805 6.50785C169.8 9.64519 170.807 14.1865 169.415 18.2959Z",
    fill: "#FFC733"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.f2981b5049a5a14cc9b8c3ef98f5d084.svg";
export { ForwardRef as ReactComponent };